module.exports = __webpack_public_path__ + "img/prioritas_vippack_dfod.a5674819.png";